function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.4,1H.6a.6.6,0,0,0-.6.6V22.4a.594.594,0,0,0,.15.387c-.014.031,0,.039.022.032A.6.6,0,0,0,.6,23H23.4a.6.6,0,0,0,.6-.6V1.6A.6.6,0,0,0,23.4,1ZM1.2,3.048l1.2,1.2v15.5l-1.2,1.2Zm19.2,11.9L15.424,9.976a.6.6,0,0,0-.848,0L11.4,13.152,9.424,11.176a.6.6,0,0,0-.8-.045L3.6,15.151V4.6H20.4ZM3.6,16.689,8.955,12.4l3.221,3.22a.6.6,0,1,0,.848-.848L12.248,14,15,11.248l5.4,5.4V19.4H3.6ZM20.752,3.4H3.248l-1.2-1.2h19.9ZM3.248,20.6h17.5l1.2,1.2H2.048ZM21.6,19.752V4.248l1.2-1.2v17.9Z",
  transform: "translate(0 -1)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/valuable_items.7c327895.svg";
export { SvgComponent as ReactComponent };